<div class="image-quality-rating">
  <span class="image-quality-label" translate>
    i18n.control.imageQuality.imageSuitability
  </span>
  <div class="image-quality-box">
    <mat-icon svgIcon="stars"
              class="image-quality-stars set-star-{{imageQualityRating}}"
              #imageQualitySVG
              ></mat-icon>
  </div>
</div>
